import type { ShirtData } from "./types";

type UseCanvasVisibilityParams = {
  shirtData: ShirtData | null;
  artworkImage?: HTMLImageElement | undefined;
  readonly: boolean;
  isSelected: boolean;
  isDragging: boolean;
  roundedWidth: number;
  roundedHeight: number;
};

type CanvasVisibility = {
  showPrintableArea: boolean;
  showNeckline: boolean;
  showWidthLabel: boolean;
  showHeightLabel: boolean;
};

export function useCanvasVisibility({
  shirtData,
  artworkImage,
  readonly,
  isSelected,
  isDragging,
  roundedWidth,
  roundedHeight
}: UseCanvasVisibilityParams): CanvasVisibility {
  const baseVisible = Boolean(shirtData && artworkImage && !readonly && isSelected) || isDragging;

  return {
    showPrintableArea: isDragging,
    showNeckline: baseVisible,
    showWidthLabel: baseVisible && roundedWidth > 0,
    showHeightLabel: baseVisible && roundedHeight > 0
  };
}
